import React from "react";

interface SectionTitleProps {
  children: React.ReactNode;
}

/**
 * Component for section titles in forms
 */
const SectionTitle: React.FC<SectionTitleProps> = ({ children }) => {
  return (
    <h2 className="text-[20px] font-bold uppercase tracking-[0.05em] text-[#323232] mb-6">
      {children}
    </h2>
  );
};

export default SectionTitle;
